export default class ModuleLoaderError extends Error {
  constructor(url, message) {
    super();
    this.name = 'ModuleLoaderError';
    this.url = url;
    this.logSource = 'infra-module-loader';
    this.message = `Failed to fetch dynamically imported module: ${url}; ${message}`;
  }
}
